import brandlogo from "../assets/images/brandlogo.png";
import headerImage from "../assets/images/headerImage.png";
import estateheader from "../assets/images/estateheader.png";
import fitnessheader from "../assets/images/fitnessheader.png";
import gradient from "../assets/images/gradient.png";
import appstorebtn from "../assets/images/appstorebtn.png";
import googleplaybtn from "../assets/images/googleplaybtn.png";
import smilinglady from "../assets/images/smilinglady.png";
import smilinglady2 from "../assets/images/smilinglady2.png";
import downArrow from "../assets/images/downArrow.png";
import switchcommunity from "../assets/images/switchcommunity.png";
import master from "../assets/images/master.png";
import friends from "../assets/images/friends.png";
import frontarrow from "../assets/images/frontarrow.png";
import gclub from "../assets/images/gclub.png";
import gclubbig from "../assets/images/gclubbig.png";
import moneyman from "../assets/images/moneyman.png";
import amount from "../assets/images/amount.png";
import amountsmall from "../assets/images/amountsmall.png";
import membership from "../assets/images/membership.png";
import events from "../assets/images/events.png";
import discussion from "../assets/images/discussion.png";
import payment from "../assets/images/payment.png";
import courses from "../assets/images/courses.png";
import one from "../assets/images/one.png";
import two from "../assets/images/two.png";
import three from "../assets/images/three.png";
import manageImage from "../assets/images/manageImage.png";
import estate1 from "../assets/images/estate/im1.png";
import estate2 from "../assets/images/estate/im2.png";
import estate3 from "../assets/images/estate/im3.png";
import estate4 from "../assets/images/estate/im4.png";
import estate5 from "../assets/images/estate/im5.png";
import estate6 from "../assets/images/estate/im6.png";
import estate7 from "../assets/images/estate/im7.png";
import managefitness from "../assets/images/fitness/managefitness.png";
import fitness1 from "../assets/images/fitness/im1.png";
import fitness2 from "../assets/images/fitness/im2.png";
import fitness3 from "../assets/images/fitness/im3.png";
import fitness4 from "../assets/images/fitness/im4.png";
import fitness5 from "../assets/images/fitness/im5.png";
import fitness6 from "../assets/images/fitness/im6.png";
import fitness7 from "../assets/images/fitness/im7.png";
import estateheaderImage from "../assets/images/estate/estateheader.png";
import estatesignup from "../assets/images/estate/estatesignup.png";
import fitnessheaderImage from "../assets/images/fitness/fitnessheader.png";
import fitnesssignup from "../assets/images/fitness/fitnesssignup.png";
import appstorewhitebtn from "../assets/images/applewhitebtn.png";
import googlewhitebtn from "../assets/images/googlewhitebtn.png";
import brandlogowhite from "../assets/images/brandlogowhite.png";
import gatepass from "../assets/images/gatepass.png";
import residentID from "../assets/images/residentID.png";
import membershipImage from "../assets/images/membershipImage.png";
import accesscontrolImage from "../assets/images/accesscontrolImage.png";
import productImage1 from "../assets/images/product/product1.png";
import productImage2 from "../assets/images/product/product2.png";
import productImage3 from "../assets/images/product/product3.png";
import p1 from "./images/product/p1.png";
import p2 from "./images/product/p2.png";
import p3 from "./images/product/p3.png";
import p4 from "./images/product/p4.png";
import p5 from "./images/product/p5.png";
import p6 from "./images/product/p6.png";

const internationalCodes = [
  { code: "+1", countryCode: "USA", name: "United States" },
  { code: "+234", countryCode: "NG", name: "Nigeria" },
  // Add more codes as needed
];

const chevronDown = (
  <svg
    width="12"
    height="7"
    viewBox="0 0 12 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.12 0.290059L6 4.17006L9.88 0.290059C10.27 -0.0999414 10.9 -0.0999414 11.29 0.290059C11.68 0.680059 11.68 1.31006 11.29 1.70006L6.7 6.29006C6.31 6.68006 5.68 6.68006 5.29 6.29006L0.700001 1.70006C0.310001 1.31006 0.310001 0.680059 0.700001 0.290059C1.09 -0.0899414 1.73 -0.0999414 2.12 0.290059Z"
      fill="currentColor"
    />
  </svg>
);

const checkIcon = (
  <svg
    width="12"
    height="8"
    viewBox="0 0 12 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3656 0.234412C11.5156 0.384435 11.5998 0.587881 11.5998 0.800012C11.5998 1.01214 11.5156 1.21559 11.3656 1.36561L4.96559 7.76561C4.81557 7.91559 4.61212 7.99984 4.39999 7.99984C4.18786 7.99984 3.98441 7.91559 3.83439 7.76561L0.63439 4.56561C0.488664 4.41473 0.408028 4.21265 0.409851 4.00289C0.411674 3.79313 0.495809 3.59248 0.644135 3.44416C0.792462 3.29583 0.993112 3.2117 1.20287 3.20987C1.41263 3.20805 1.61471 3.28869 1.76559 3.43441L4.39999 6.06881L10.2344 0.234412C10.3844 0.0844355 10.5879 0.000183105 10.8 0.000183105C11.0121 0.000183105 11.2156 0.0844355 11.3656 0.234412Z"
      fill="white"
    />
  </svg>
);

const plusIcon = (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 1.5V15.5M1 8.5H15"
      stroke="#112A62"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const VolumeUpIcon = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.07 4.92993C20.9447 6.80521 21.9979 9.34829 21.9979 11.9999C21.9979 14.6516 20.9447 17.1947 19.07 19.0699M15.54 8.45993C16.4774 9.39757 17.0039 10.6691 17.0039 11.9949C17.0039 13.3208 16.4774 14.5923 15.54 15.5299M11 4.99993L6 8.99993H2V14.9999H6L11 18.9999V4.99993Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const VolumeMuteIcon = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23 9L17 15M17 9L23 15M11 5L6 9H2V15H6L11 19V5Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const closeIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 5.90991L6 18.0899"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 5.90991L18 18.0899"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const closeIconOverlay = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 5.90991L6 18.0899"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 5.90991L18 18.0899"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const sendIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="24"
    height="24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeWidth="2"
      d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
    />
  </svg>
);
const hamburgerIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 12H20M4 6H20M4 18H20"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const moneyIcon = (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.8838 16.1573C15.5804 14.6438 14.9384 13.3969 13.1649 12.6246L10.2267 11.4114C9.27479 11.0184 8.18411 11.1803 7.38727 11.833L4.68515 14.0463L4.60657 14.8344L4.47998 21.2797V22.3997H7.74925L14.4168 24.2942C15.2579 24.5332 16.1623 24.365 16.8615 23.8395C21.2547 20.5373 24.1901 18.3075 24.6347 17.8942C25.7123 16.8921 26.1366 15.778 25.3687 14.6798C24.7481 13.7921 23.7013 13.6974 22.404 14.2847L16.0941 17.4939L14.3199 16.9296C14.5486 16.7324 14.7373 16.4755 14.8838 16.1573Z"
      fill="#1565D8"
    />
    <path
      opacity="0.3"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.9475 4.48109H19.6V4.20048C19.6 3.73629 19.224 3.35986 18.76 3.35986C18.296 3.35986 17.92 3.73629 17.92 4.20048V4.48109H17.6556C16.5731 4.48109 15.6956 5.35951 15.6956 6.44293V7.00439C15.6956 8.08782 16.5731 8.96624 17.6556 8.96624H19.88C20.0346 8.96624 20.16 9.0918 20.16 9.24685V9.80661C20.16 9.96166 20.0346 10.0872 19.88 10.0872H17.3098C17.1855 9.79232 16.898 9.58393 16.5612 9.57368C16.0974 9.55956 15.7101 9.92437 15.696 10.3884L15.6804 10.9023C15.666 11.3763 16.046 11.7685 16.52 11.7685H17.92V12.0392C17.92 12.5034 18.296 12.8799 18.76 12.8799C19.224 12.8799 19.6 12.5034 19.6 12.0392V11.7685H19.88C20.9625 11.7685 21.84 10.89 21.84 9.80661V9.24685C21.84 8.16342 20.9625 7.28501 19.88 7.28501H17.6556C17.501 7.28501 17.3756 7.15944 17.3756 7.00439V6.44293C17.3756 6.28788 17.501 6.16232 17.6556 6.16232H20.2174C20.3634 6.41855 20.6385 6.58675 20.9475 6.58675C21.4114 6.58675 21.7875 6.21032 21.7875 5.74613V5.3217C21.7875 4.85752 21.4114 4.48109 20.9475 4.48109ZM3.91999 12.5999H4.19999V23.2399H3.91999C3.45607 23.2399 3.07999 23.6159 3.07999 24.0799C3.07999 24.5438 3.45607 24.9199 3.91999 24.9199H5.03999C5.50391 24.9199 5.87999 24.5438 5.87999 24.0799V11.7599C5.87999 11.2959 5.50391 10.9199 5.03999 10.9199H3.91999C3.45607 10.9199 3.07999 11.2959 3.07999 11.7599C3.07999 12.2238 3.45607 12.5999 3.91999 12.5999Z"
      fill="#1565D8"
    />
  </svg>
);

const protectionIcon = (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.2702 5.91352L14.1902 2.27352C14.0673 2.22914 13.9327 2.22914 13.8098 2.27352L3.7298 5.91352C3.50788 5.99366 3.36 6.20429 3.36 6.44023V14.0002C3.36 19.9369 6.9055 23.8763 13.8549 25.7411C13.9512 25.7669 14.0527 25.7666 14.1488 25.7401C21.0959 23.8251 24.64 19.8871 24.64 14.0002V6.44023C24.64 6.20429 24.4921 5.99366 24.2702 5.91352ZM10.134 13.0207C10.358 12.8075 10.7125 12.8163 10.9257 13.0403L13.1911 15.4211L17.9483 10.2607C18.1579 10.0333 18.5122 10.0189 18.7396 10.2285C18.967 10.4381 18.9814 10.7924 18.7717 11.0198L13.6093 16.6198C13.3899 16.8578 13.015 16.8608 12.7919 16.6263L10.1143 13.8124C9.90112 13.5883 9.90992 13.2339 10.134 13.0207Z"
      fill="#1565D8"
    />
  </svg>
);

const personIcon = (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.37359 9.9336C12.335 10.6338 16.2157 8.8254 18.918 4.53278C18.9316 4.51126 18.944 4.4892 18.9552 4.46668C19.9952 5.63694 20.6269 7.17815 20.6269 8.8669V11.2936C20.6269 13.7461 19.2821 15.9509 17.1974 17.0995C16.9258 16.9108 16.5958 16.8002 16.24 16.8002C15.3121 16.8002 14.56 17.5524 14.56 18.4802C14.56 19.4081 15.3121 20.1602 16.24 20.1602C16.7099 20.1602 17.1347 19.9673 17.4396 19.6564C16.9853 21.0835 15.6172 22.1202 14 22.1202C12.0133 22.1202 10.4025 20.5556 10.4 18.6247L10.9312 17.1683C8.77363 16.0405 7.37359 13.796 7.37359 11.2936V9.9336ZM7.38673 8.4463C7.60368 4.98246 10.4817 2.24023 14.0003 2.24023C15.4832 2.24023 16.8524 2.72736 17.9565 3.55033C17.9226 3.58523 17.8915 3.62476 17.8637 3.66881C15.4316 7.53213 11.994 9.11833 7.45186 8.45213C7.43001 8.44892 7.40828 8.447 7.38673 8.4463ZM9.01669 19.3577C9.38254 21.714 11.4743 23.5202 14 23.5202C16.5262 23.5202 18.6183 21.7133 18.9835 19.3563L21.6689 19.8977C22.7356 20.1059 23.5856 20.9125 23.8491 21.9668L24.6235 25.0644C24.7119 25.4179 24.4446 25.7602 24.0803 25.7602H3.92026C3.55594 25.7602 3.28862 25.4179 3.37698 25.0644L4.15037 21.9708C4.41461 20.9139 5.26797 20.1062 6.33247 19.9014L9.01669 19.3577Z"
      fill="#1565D8"
    />
    <path
      opacity="0.3"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.24 19.0399C16.5493 19.0399 16.8 18.7892 16.8 18.4799C16.8 18.1706 16.5493 17.9199 16.24 17.9199C15.9307 17.9199 15.68 18.1706 15.68 18.4799C15.68 18.7892 15.9307 19.0399 16.24 19.0399Z"
      fill="#1565D8"
    />
    <path
      opacity="0.3"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.6795 7.83984H21.84C22.7678 7.83984 23.52 8.59201 23.52 9.51984V11.7598C23.52 12.6877 22.7678 13.4398 21.84 13.4398H21.4443C21.6423 12.7526 21.7469 12.0313 21.7469 11.2932V8.86651C21.7469 8.51845 21.724 8.17575 21.6795 7.83984Z"
      fill="#1565D8"
    />
    <path
      opacity="0.3"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.55628 13.4398H6.16001C5.23217 13.4398 4.48001 12.6877 4.48001 11.7598V9.51984C4.48001 8.59201 5.23217 7.83984 6.16001 7.83984H6.32105C6.27657 8.17575 6.25362 8.51845 6.25362 8.86651V11.2932C6.25362 12.0313 6.35823 12.7526 6.55628 13.4398Z"
      fill="#1565D8"
    />
  </svg>
);

const likeIcon = (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.04479 10.9915C9.51669 8.8998 10.4355 6.49962 10.8041 3.78238C10.8392 3.52354 11.0224 3.3083 11.2739 3.23047C13.8087 2.44603 15.2498 3.69257 15.226 6.53496C15.2213 7.0867 15.1959 7.57711 15.1417 8.32716C15.0206 10.0025 15.0302 10.4597 15.2178 10.7674C15.3981 11.0631 15.9835 11.1641 17.3679 10.9012C17.8047 10.8183 18.2429 10.7243 18.7283 10.6114C18.9426 10.5615 20.4859 10.1849 20.8804 10.0998C21.6329 9.93727 22.1728 9.8685 22.6476 9.89762C23.9339 9.97651 24.6164 10.8047 24.7344 12.3913C24.9421 15.1855 24.3003 20.798 23.66 22.8653C23.0058 24.9778 21.8648 25.7752 19.1259 25.8233C17.365 25.8543 14.6567 25.8543 10.9883 25.8232C10.0519 25.8015 9.20326 25.6201 8.44839 25.2811C8.66028 24.8424 8.77895 24.3509 8.77895 23.832V13.08C8.77895 12.2907 8.50439 11.5649 8.04479 10.9915Z"
      fill="#1565D8"
    />
    <path
      opacity="0.3"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.03368 11.064C2.91051 11.064 2 11.9666 2 13.08V23.832C2 24.9454 2.91051 25.848 4.03368 25.848H5.38947C6.51265 25.848 7.42316 24.9454 7.42316 23.832V13.08C7.42316 11.9666 6.51265 11.064 5.38947 11.064H4.03368Z"
      fill="#1565D8"
    />
  </svg>
);

const pricingCheckIcon = (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9875 1.36104C11.0562 0.574966 9.6938 0.574967 8.76249 1.36104L7.91432 2.07692C7.51849 2.41102 7.02865 2.61394 6.5125 2.65759L5.40655 2.75111C4.19217 2.85381 3.22881 3.81717 3.12611 5.03155L3.03259 6.1375C2.98894 6.65365 2.78602 7.14349 2.45192 7.53934L1.73604 8.38749C0.949966 9.3188 0.949967 10.6812 1.73604 11.6125L2.45192 12.4607C2.78602 12.8565 2.98894 13.3464 3.03259 13.8625L3.12611 14.9685C3.22881 16.1829 4.19217 17.1462 5.40655 17.2489L6.5125 17.3424C7.02865 17.3861 7.51849 17.589 7.91434 17.9231L8.76249 18.639C9.6938 19.425 11.0562 19.425 11.9875 18.639L12.8357 17.9231C13.2315 17.589 13.7214 17.3861 14.2375 17.3424L15.3435 17.2489C16.5579 17.1462 17.5212 16.1829 17.6239 14.9685L17.7174 13.8625C17.7611 13.3464 17.964 12.8565 18.2981 12.4607L19.014 11.6125C19.8 10.6812 19.8 9.3188 19.014 8.38749L18.2981 7.53932C17.964 7.14349 17.7611 6.65365 17.7174 6.1375L17.6239 5.03155C17.5212 3.81717 16.5579 2.85381 15.3435 2.75111L14.2375 2.65759C13.7214 2.61394 13.2315 2.41102 12.8357 2.07692L11.9875 1.36104ZM14.921 8.29555C15.3604 7.85621 15.3604 7.1439 14.921 6.70456C14.4817 6.26521 13.7694 6.26521 13.33 6.70456L9.12554 10.9091L7.42104 9.20456C6.9817 8.76521 6.26939 8.76521 5.83005 9.20456C5.3907 9.6439 5.3907 10.3562 5.83005 10.7956L8.33005 13.2955C8.76939 13.7349 9.4817 13.7349 9.92104 13.2955L14.921 8.29555Z"
      fill="#0084C9"
    />
  </svg>
);

const dashedIcon = (
  <svg
    width="15"
    height="2"
    viewBox="0 0 15 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.54199 1H13.2086"
      stroke="#98A2B3"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const question = (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_619_454"
      maskUnits="userSpaceOnUse"
      masktype="luminance"
      x="0"
      y="0"
      width="17"
      height="16"
    >
      <path d="M16.75 0H0.75V16H16.75V0Z" fill="white" />
    </mask>
    <g mask="url(#mask0_619_454)">
      <path
        d="M6.80968 6.00017C6.96641 5.55461 7.27578 5.17891 7.68298 4.93959C8.09018 4.70028 8.56894 4.6128 9.03446 4.69264C9.49998 4.77249 9.92222 5.01452 10.2264 5.37586C10.5306 5.73719 10.697 6.19452 10.6963 6.66684C10.6963 8.00017 8.69635 8.66684 8.69635 8.66684M8.74968 11.3335H8.75635M15.4164 8.00017C15.4164 11.6821 12.4316 14.6668 8.74968 14.6668C5.06778 14.6668 2.08301 11.6821 2.08301 8.00017C2.08301 4.31827 5.06778 1.3335 8.74968 1.3335C12.4316 1.3335 15.4164 4.31827 15.4164 8.00017Z"
        stroke="#98A2B3"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

const closeIcon2 = (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 15L15 2"
      stroke="#29B6F6"
      strokeWidth="2.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 15L2 2"
      stroke="#29B6F6"
      strokeWidth="2.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const chatIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="20"
    height="20"
  >
    <path
      d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
      stroke="#101828"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const chatIconWhite = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="20"
    height="20"
  >
    <path
      d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const emptyState = (
  <svg
    width="152"
    height="120"
    viewBox="0 0 152 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="76" cy="52" r="52" fill="#E4E7EC" />
    <g filter="url(#filter0_dd_1182_1994)">
      <path
        d="M77.6 16C66.8273 16 57.2978 21.3233 51.4987 29.4829C49.605 29.0363 47.6301 28.8 45.6 28.8C31.4615 28.8 20 40.2615 20 54.4C20 68.5385 31.4615 80 45.6 80L109.6 80C121.971 80 132 69.9712 132 57.6C132 45.2288 121.971 35.2 109.6 35.2C108.721 35.2 107.854 35.2506 107.002 35.349C102.098 23.9677 90.7797 16 77.6 16Z"
        fill="#F9FAFB"
      />
      <ellipse
        cx="45.6"
        cy="54.4"
        rx="25.6"
        ry="25.6"
        fill="url(#paint0_linear_1182_1994)"
      />
      <circle cx="77.6" cy="48" r="32" fill="url(#paint1_linear_1182_1994)" />
      <ellipse
        cx="109.6"
        cy="57.5999"
        rx="22.4"
        ry="22.4"
        fill="url(#paint2_linear_1182_1994)"
      />
    </g>
    <circle cx="21" cy="19" r="5" fill="#F2F4F7" />
    <circle cx="18" cy="109" r="7" fill="#F2F4F7" />
    <circle cx="145" cy="35" r="7" fill="#F2F4F7" />
    <circle cx="134" cy="8" r="4" fill="#F2F4F7" />
    <rect
      x="52"
      y="62"
      width="48"
      height="48"
      rx="24"
      fill="#344054"
      fill-opacity="0.4"
    />
    <path
      d="M85 95L80.65 90.65M83 85C83 89.4183 79.4183 93 75 93C70.5817 93 67 89.4183 67 85C67 80.5817 70.5817 77 75 77C79.4183 77 83 80.5817 83 85Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <defs>
      <filter
        id="filter0_dd_1182_1994"
        x="0"
        y="16"
        width="152"
        height="104"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="4"
          operator="erode"
          in="SourceAlpha"
          result="effect1_dropShadow_1182_1994"
        />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.04 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1182_1994"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="4"
          operator="erode"
          in="SourceAlpha"
          result="effect2_dropShadow_1182_1994"
        />
        <feOffset dy="20" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1182_1994"
          result="effect2_dropShadow_1182_1994"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_1182_1994"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1182_1994"
        x1="25.9429"
        y1="37.4858"
        x2="71.2"
        y2="80"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D0D5DD" />
        <stop offset="0.350715" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1182_1994"
        x1="53.0286"
        y1="26.8571"
        x2="109.6"
        y2="80"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D0D5DD" />
        <stop offset="0.350715" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1182_1994"
        x1="92.4"
        y1="42.8"
        x2="132"
        y2="79.9999"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D0D5DD" />
        <stop offset="0.350715" stop-color="white" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

const emptyCartState = (
  <svg
    width="196"
    height="160"
    viewBox="0 0 196 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect x="22" y="18" width="152" height="118" rx="28" fill="#EAF6FD" />
    <circle cx="152" cy="36" r="12" fill="#BFE6FA" />
    <circle cx="42" cy="122" r="10" fill="#CDEFD8" />
    <path
      d="M56 54H72.5L83.2 99.6C84.1 103.4 87.5 106 91.4 106H132.6C136.4 106 139.8 103.5 140.8 99.8L149 70H78"
      stroke="#0E86D4"
      strokeWidth="7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M88 82H144"
      stroke="#7CC9EF"
      strokeWidth="7"
      strokeLinecap="round"
    />
    <circle cx="94" cy="122" r="8" fill="#0E86D4" />
    <circle cx="130" cy="122" r="8" fill="#0E86D4" />
    <path
      d="M99 46C102.5 39.5 109 36 116.5 36C124 36 130.5 39.5 134 46"
      stroke="#16A34A"
      strokeWidth="6"
      strokeLinecap="round"
    />
  </svg>
);

const cartIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 1H5L7.68 14.39C7.77144 14.8504 8.02191 15.264 8.38755 15.5583C8.75318 15.8526 9.2107 16.009 9.68 16H19.4C19.8693 16.009 20.3268 15.8526 20.6925 15.5583C21.0581 15.264 21.3086 14.8504 21.4 14.39L23 6H6M10 21C10 21.5523 9.55228 22 9 22C8.44772 22 8 21.5523 8 21C8 20.4477 8.44772 20 9 20C9.55228 20 10 20.4477 10 21ZM21 21C21 21.5523 20.5523 22 20 22C19.4477 22 19 21.5523 19 21C19 20.4477 19.4477 20 20 20C20.5523 20 21 20.4477 21 21Z"
      stroke="#101828"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const scrollTopIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 12L12 8M12 8L8 12M12 8V16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      stroke="#101828"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const scrollDownIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 12L12 16M12 16L16 12M12 16V8M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      stroke="#101828"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const userIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
      stroke="#101828"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const userIcon2 = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
    class="size-6"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
    />
  </svg>
);

const leftArrowIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
    class="size-6"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
    />
  </svg>
);
const rightArrowIcon = (
  <svg
    width="24"
    height="24"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
    />
  </svg>
);

const ordersIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
    class="size-6"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M15.75 10.5V6a3.75 3.75 0 1 0-7.5 0v4.5m11.356-1.993 1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 0 1-1.12-1.243l1.264-12A1.125 1.125 0 0 1 5.513 7.5h12.974c.576 0 1.059.435 1.119 1.007ZM8.625 10.5a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm7.5 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
    />
  </svg>
);

const google = (
  <svg
    className="btn__icon btn__icon--google"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid"
    viewBox="0 0 20 20"
    background="#167bbc"
  >
    <path
      d="M4.942627,18.0508423l7.6660156-4.3273926l-1.6452026-1.8234253L4.942627,18.0508423z M2.1422119,2.1231079
        C2.0543823,2.281311,2,2.4631958,2,2.664917v15.1259766c0,0.2799683,0.1046143,0.5202026,0.2631226,0.710144l7.6265259-7.7912598
        L2.1422119,2.1231079z M17.4795532,9.4819336l-2.6724854-1.508606l-2.72229,2.7811279l1.9516602,2.1630249l3.4431152-1.9436035
        C17.7927856,10.8155518,17.9656372,10.5287476,18,10.2279053C17.9656372,9.927063,17.7927856,9.6402588,17.4795532,9.4819336z
         M13.3649292,7.1592407L4.1452026,1.954834l6.8656616,7.609314L13.3649292,7.1592407z"
    />
  </svg>
);

const apple = (
  <svg
    className="btn__icon btn__icon--apple"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid"
    viewBox="0 0 20 20"
    background="#167bbc"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.5640259,13.8623047
        c-0.4133301,0.9155273-0.6115723,1.3251343-1.1437988,2.1346436c-0.7424927,1.1303711-1.7894897,2.5380249-3.086853,2.5500488
        c-1.1524048,0.0109253-1.4483032-0.749939-3.0129395-0.741333c-1.5640259,0.008606-1.8909302,0.755127-3.0438843,0.7442017
        c-1.296814-0.0120239-2.2891235-1.2833252-3.0321655-2.4136963c-2.0770874-3.1607666-2.2941895-6.8709106-1.0131836-8.8428955
        c0.9106445-1.4013062,2.3466187-2.2217407,3.6970215-2.2217407c1.375,0,2.239502,0.7539673,3.3761597,0.7539673
        c1.1028442,0,1.7749023-0.755127,3.3641357-0.755127c1.201416,0,2.4744263,0.6542969,3.3816528,1.7846069
        C14.0778809,8.4837646,14.5608521,12.7279663,17.5640259,13.8623047z M12.4625244,3.8076782
        c0.5775146-0.741333,1.0163574-1.7880859,0.8571167-2.857666c-0.9436035,0.0653076-2.0470581,0.6651611-2.6912842,1.4477539	C10.0437012,3.107605,9.56073,4.1605835,9.7486572,5.1849365C10.7787476,5.2164917,11.8443604,4.6011963,12.4625244,3.8076782z"
    />
  </svg>
);

const calender = (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99984 16.4692C10.1647 16.4692 10.3258 16.4204 10.4628 16.3288C10.5999 16.2372 10.7067 16.1071 10.7697 15.9548C10.8328 15.8025 10.8493 15.635 10.8172 15.4733C10.785 15.3117 10.7056 15.1632 10.5891 15.0466C10.4725 14.9301 10.3241 14.8507 10.1624 14.8186C10.0008 14.7864 9.83321 14.8029 9.68093 14.866C9.52866 14.9291 9.39851 15.0359 9.30695 15.1729C9.21538 15.31 9.1665 15.4711 9.1665 15.6359C9.1665 15.8569 9.2543 16.0689 9.41058 16.2252C9.56686 16.3814 9.77882 16.4692 9.99984 16.4692ZM14.1665 16.4692C14.3313 16.4692 14.4924 16.4204 14.6295 16.3288C14.7665 16.2372 14.8733 16.1071 14.9364 15.9548C14.9995 15.8025 15.016 15.635 14.9838 15.4733C14.9517 15.3117 14.8723 15.1632 14.7558 15.0466C14.6392 14.9301 14.4907 14.8507 14.3291 14.8186C14.1674 14.7864 13.9999 14.8029 13.8476 14.866C13.6953 14.9291 13.5652 15.0359 13.4736 15.1729C13.382 15.31 13.3332 15.4711 13.3332 15.6359C13.3332 15.8569 13.421 16.0689 13.5772 16.2252C13.7335 16.3814 13.9455 16.4692 14.1665 16.4692ZM14.1665 13.1359C14.3313 13.1359 14.4924 13.087 14.6295 12.9955C14.7665 12.9039 14.8733 12.7737 14.9364 12.6215C14.9995 12.4692 15.016 12.3016 14.9838 12.14C14.9517 11.9783 14.8723 11.8299 14.7558 11.7133C14.6392 11.5968 14.4907 11.5174 14.3291 11.4852C14.1674 11.4531 13.9999 11.4696 13.8476 11.5327C13.6953 11.5957 13.5652 11.7026 13.4736 11.8396C13.382 11.9766 13.3332 12.1378 13.3332 12.3026C13.3332 12.5236 13.421 12.7355 13.5772 12.8918C13.7335 13.0481 13.9455 13.1359 14.1665 13.1359ZM9.99984 13.1359C10.1647 13.1359 10.3258 13.087 10.4628 12.9955C10.5999 12.9039 10.7067 12.7737 10.7697 12.6215C10.8328 12.4692 10.8493 12.3016 10.8172 12.14C10.785 11.9783 10.7056 11.8299 10.5891 11.7133C10.4725 11.5968 10.3241 11.5174 10.1624 11.4852C10.0008 11.4531 9.83321 11.4696 9.68093 11.5327C9.52866 11.5957 9.39851 11.7026 9.30695 11.8396C9.21538 11.9766 9.1665 12.1378 9.1665 12.3026C9.1665 12.5236 9.2543 12.7355 9.41058 12.8918C9.56686 13.0481 9.77882 13.1359 9.99984 13.1359ZM15.8332 3.1359H14.9998V2.30257C14.9998 2.08156 14.912 1.8696 14.7558 1.71332C14.5995 1.55704 14.3875 1.46924 14.1665 1.46924C13.9455 1.46924 13.7335 1.55704 13.5772 1.71332C13.421 1.8696 13.3332 2.08156 13.3332 2.30257V3.1359H6.6665V2.30257C6.6665 2.08156 6.57871 1.8696 6.42243 1.71332C6.26615 1.55704 6.05418 1.46924 5.83317 1.46924C5.61216 1.46924 5.4002 1.55704 5.24392 1.71332C5.08764 1.8696 4.99984 2.08156 4.99984 2.30257V3.1359H4.1665C3.50346 3.1359 2.86758 3.3993 2.39874 3.86814C1.9299 4.33698 1.6665 4.97286 1.6665 5.6359V17.3026C1.6665 17.9656 1.9299 18.6015 2.39874 19.0703C2.86758 19.5392 3.50346 19.8026 4.1665 19.8026H15.8332C16.4962 19.8026 17.1321 19.5392 17.6009 19.0703C18.0698 18.6015 18.3332 17.9656 18.3332 17.3026V5.6359C18.3332 4.97286 18.0698 4.33698 17.6009 3.86814C17.1321 3.3993 16.4962 3.1359 15.8332 3.1359ZM16.6665 17.3026C16.6665 17.5236 16.5787 17.7355 16.4224 17.8918C16.2661 18.0481 16.0542 18.1359 15.8332 18.1359H4.1665C3.94549 18.1359 3.73353 18.0481 3.57725 17.8918C3.42097 17.7355 3.33317 17.5236 3.33317 17.3026V9.80257H16.6665V17.3026ZM16.6665 8.1359H3.33317V5.6359C3.33317 5.41489 3.42097 5.20293 3.57725 5.04665C3.73353 4.89037 3.94549 4.80257 4.1665 4.80257H4.99984V5.6359C4.99984 5.85692 5.08764 6.06888 5.24392 6.22516C5.4002 6.38144 5.61216 6.46924 5.83317 6.46924C6.05418 6.46924 6.26615 6.38144 6.42243 6.22516C6.57871 6.06888 6.6665 5.85692 6.6665 5.6359V4.80257H13.3332V5.6359C13.3332 5.85692 13.421 6.06888 13.5772 6.22516C13.7335 6.38144 13.9455 6.46924 14.1665 6.46924C14.3875 6.46924 14.5995 6.38144 14.7558 6.22516C14.912 6.06888 14.9998 5.85692 14.9998 5.6359V4.80257H15.8332C16.0542 4.80257 16.2661 4.89037 16.4224 5.04665C16.5787 5.20293 16.6665 5.41489 16.6665 5.6359V8.1359ZM5.83317 13.1359C5.99799 13.1359 6.1591 13.087 6.29615 12.9955C6.43319 12.9039 6.54 12.7737 6.60307 12.6215C6.66614 12.4692 6.68265 12.3016 6.65049 12.14C6.61834 11.9783 6.53897 11.8299 6.42243 11.7133C6.30588 11.5968 6.1574 11.5174 5.99575 11.4852C5.8341 11.4531 5.66654 11.4696 5.51427 11.5327C5.362 11.5957 5.23185 11.7026 5.14028 11.8396C5.04871 11.9766 4.99984 12.1378 4.99984 12.3026C4.99984 12.5236 5.08764 12.7355 5.24392 12.8918C5.4002 13.0481 5.61216 13.1359 5.83317 13.1359ZM5.83317 16.4692C5.99799 16.4692 6.1591 16.4204 6.29615 16.3288C6.43319 16.2372 6.54 16.1071 6.60307 15.9548C6.66614 15.8025 6.68265 15.635 6.65049 15.4733C6.61834 15.3117 6.53897 15.1632 6.42243 15.0466C6.30588 14.9301 6.1574 14.8507 5.99575 14.8186C5.8341 14.7864 5.66654 14.8029 5.51427 14.866C5.362 14.9291 5.23185 15.0359 5.14028 15.1729C5.04871 15.31 4.99984 15.4711 4.99984 15.6359C4.99984 15.8569 5.08764 16.0689 5.24392 16.2252C5.4002 16.3814 5.61216 16.4692 5.83317 16.4692Z"
      fill="#757575"
    />
  </svg>
);

const mapIcon = (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0002 2.30225C8.23205 2.30225 6.53636 3.00463 5.28612 4.25487C4.03588 5.50511 3.3335 7.2008 3.3335 8.96891C3.3335 13.4689 9.2085 18.5522 9.4585 18.7689C9.60944 18.898 9.80154 18.969 10.0002 18.969C10.1988 18.969 10.3909 18.898 10.5418 18.7689C10.8335 18.5522 16.6668 13.4689 16.6668 8.96891C16.6668 7.2008 15.9645 5.50511 14.7142 4.25487C13.464 3.00463 11.7683 2.30225 10.0002 2.30225ZM10.0002 17.0106C8.22516 15.3439 5.00016 11.7522 5.00016 8.96891C5.00016 7.64283 5.52695 6.37106 6.46463 5.43338C7.40231 4.4957 8.67408 3.96891 10.0002 3.96891C11.3262 3.96891 12.598 4.4957 13.5357 5.43338C14.4734 6.37106 15.0002 7.64283 15.0002 8.96891C15.0002 11.7522 11.7752 15.3522 10.0002 17.0106ZM10.0002 5.63558C9.34089 5.63558 8.69643 5.83108 8.14826 6.19735C7.6001 6.56362 7.17286 7.08421 6.92056 7.6933C6.66827 8.30239 6.60226 8.97261 6.73088 9.61921C6.8595 10.2658 7.17696 10.8598 7.64314 11.3259C8.10931 11.7921 8.70326 12.1096 9.34986 12.2382C9.99647 12.3668 10.6667 12.3008 11.2758 12.0485C11.8849 11.7962 12.4055 11.369 12.7717 10.8208C13.138 10.2726 13.3335 9.62818 13.3335 8.96891C13.3335 8.08486 12.9823 7.23701 12.3572 6.61189C11.7321 5.98677 10.8842 5.63558 10.0002 5.63558ZM10.0002 10.6356C9.67053 10.6356 9.34829 10.5378 9.07421 10.3547C8.80013 10.1716 8.58651 9.91126 8.46036 9.60672C8.33422 9.30218 8.30121 8.96706 8.36552 8.64376C8.42983 8.32046 8.58856 8.02349 8.82165 7.7904C9.05474 7.55731 9.35171 7.39858 9.67501 7.33427C9.99831 7.26996 10.3334 7.30297 10.638 7.42911C10.9425 7.55526 11.2028 7.76888 11.3859 8.04296C11.5691 8.31704 11.6668 8.63928 11.6668 8.96891C11.6668 9.41094 11.4912 9.83486 11.1787 10.1474C10.8661 10.46 10.4422 10.6356 10.0002 10.6356Z"
      fill="#757575"
    />
  </svg>
);

const mapIcon25 = (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.4998 3C8.8098 3 5.7998 6.01 5.7998 9.7C5.7998 14.28 11.7998 21.02 12.0498 21.3C12.2898 21.57 12.7098 21.57 12.9498 21.3C13.2098 21.02 19.1998 14.28 19.1998 9.7C19.1998 6.01 16.1898 3 12.4998 3Z"
      stroke="#0E86D4"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8846 12.0352C14.1773 11.8295 15.0584 10.6147 14.8526 9.32208C14.6469 8.02939 13.4322 7.14827 12.1395 7.35403C10.8468 7.5598 9.96566 8.77452 10.1714 10.0672C10.3772 11.3599 11.5919 12.241 12.8846 12.0352Z"
      stroke="#0E86D4"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const trashCan = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="16"
    height="16"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
      d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
    />
  </svg>
);

const editIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="16"
    height="16"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
      d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
    />
  </svg>
);

const copyIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="16"
    height="16"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
      d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75"
    />
  </svg>
);

const replyIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="16"
    height="16"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      stroke="currentColor"
      d="M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3"
    />
  </svg>
);

const retryArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="size-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 2.00001V8.00001M21 8.00001H15M21 8.00001L16.37 3.64001C14.9906 2.25975 13.2 1.3652 11.268 1.09116C9.33593 0.817114 7.36717 1.17843 5.65836 2.12065C3.94954 3.06288 2.59325 4.53496 1.79386 6.31508C0.994479 8.0952 0.795309 10.0869 1.22637 11.9901C1.65743 13.8932 2.69536 15.6047 4.18376 16.8667C5.67216 18.1286 7.53038 18.8726 9.47842 18.9866C11.4265 19.1006 13.3588 18.5783 14.9842 17.4985C16.6096 16.4187 17.84 14.8399 18.49 13"
    />
  </svg>
);

const uploadIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="size-6"
    width={"20px"}
    height={"20px"}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15m0-3-3-3m0 0-3 3m3-3V15"
    />
  </svg>
);

const searchIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 21L16.65 16.65M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
      stroke="#101828"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const searchWhiteIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 21L16.65 16.65M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
      stroke="#FFFFFF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const searchIcon24 = (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 21L15.8 15.8M18 10.5C18 14.0899 15.0899 17 11.5 17C7.91015 17 5 14.0899 5 10.5C5 6.91015 7.91015 4 11.5 4C15.0899 4 18 6.91015 18 10.5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const timeIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1423_17979)">
      <path
        d="M7.7168 6.00866V4.29199"
        stroke="#0E86D4"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.2832 6.00866V4.29199"
        stroke="#0E86D4"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.042 5.15039H6.95866C5.48366 5.15039 4.29199 6.34206 4.29199 7.81706V17.0504C4.29199 18.5254 5.48366 19.7171 6.95866 19.7171H17.0503C18.5253 19.7171 19.717 18.5254 19.717 17.0504V7.81706C19.7087 6.34206 18.517 5.15039 17.042 5.15039Z"
        stroke="#0E86D4"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.29199 8.58301H19.7087"
        stroke="#0E86D4"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0003 11.9997C17.4606 11.9997 17.8337 11.6266 17.8337 11.1663C17.8337 10.7061 17.4606 10.333 17.0003 10.333C16.5401 10.333 16.167 10.7061 16.167 11.1663C16.167 11.6266 16.5401 11.9997 17.0003 11.9997Z"
        fill="#0E86D4"
      />
      <path
        d="M13.6663 11.9997C14.1266 11.9997 14.4997 11.6266 14.4997 11.1663C14.4997 10.7061 14.1266 10.333 13.6663 10.333C13.2061 10.333 12.833 10.7061 12.833 11.1663C12.833 11.6266 13.2061 11.9997 13.6663 11.9997Z"
        fill="#0E86D4"
      />
      <path
        d="M10.3333 11.9997C10.7936 11.9997 11.1667 11.6266 11.1667 11.1663C11.1667 10.7061 10.7936 10.333 10.3333 10.333C9.8731 10.333 9.5 10.7061 9.5 11.1663C9.5 11.6266 9.8731 11.9997 10.3333 11.9997Z"
        fill="#0E86D4"
      />
      <path
        d="M7.00033 11.9997C7.46056 11.9997 7.83366 11.6266 7.83366 11.1663C7.83366 10.7061 7.46056 10.333 7.00033 10.333C6.54009 10.333 6.16699 10.7061 6.16699 11.1663C6.16699 11.6266 6.54009 11.9997 7.00033 11.9997Z"
        fill="#0E86D4"
      />
      <path
        d="M17.0003 14.9079C17.4606 14.9079 17.8337 14.5348 17.8337 14.0745C17.8337 13.6143 17.4606 13.2412 17.0003 13.2412C16.5401 13.2412 16.167 13.6143 16.167 14.0745C16.167 14.5348 16.5401 14.9079 17.0003 14.9079Z"
        fill="#0E86D4"
      />
      <path
        d="M13.6663 14.9079C14.1266 14.9079 14.4997 14.5348 14.4997 14.0745C14.4997 13.6143 14.1266 13.2412 13.6663 13.2412C13.2061 13.2412 12.833 13.6143 12.833 14.0745C12.833 14.5348 13.2061 14.9079 13.6663 14.9079Z"
        fill="#0E86D4"
      />
      <path
        d="M10.3333 14.9079C10.7936 14.9079 11.1667 14.5348 11.1667 14.0745C11.1667 13.6143 10.7936 13.2412 10.3333 13.2412C9.8731 13.2412 9.5 13.6143 9.5 14.0745C9.5 14.5348 9.8731 14.9079 10.3333 14.9079Z"
        fill="#0E86D4"
      />
      <path
        d="M7.00033 14.9079C7.46056 14.9079 7.83366 14.5348 7.83366 14.0745C7.83366 13.6143 7.46056 13.2412 7.00033 13.2412C6.54009 13.2412 6.16699 13.6143 6.16699 14.0745C6.16699 14.5348 6.54009 14.9079 7.00033 14.9079Z"
        fill="#0E86D4"
      />
      <path
        d="M13.6663 17.8083C14.1266 17.8083 14.4997 17.4352 14.4997 16.9749C14.4997 16.5147 14.1266 16.1416 13.6663 16.1416C13.2061 16.1416 12.833 16.5147 12.833 16.9749C12.833 17.4352 13.2061 17.8083 13.6663 17.8083Z"
        fill="#0E86D4"
      />
      <path
        d="M10.3333 17.8083C10.7936 17.8083 11.1667 17.4352 11.1667 16.9749C11.1667 16.5147 10.7936 16.1416 10.3333 16.1416C9.8731 16.1416 9.5 16.5147 9.5 16.9749C9.5 17.4352 9.8731 17.8083 10.3333 17.8083Z"
        fill="#0E86D4"
      />
      <path
        d="M7.00033 17.8083C7.46056 17.8083 7.83366 17.4352 7.83366 16.9749C7.83366 16.5147 7.46056 16.1416 7.00033 16.1416C6.54009 16.1416 6.16699 16.5147 6.16699 16.9749C6.16699 17.4352 6.54009 17.8083 7.00033 17.8083Z"
        fill="#0E86D4"
      />
    </g>
    <defs>
      <clipPath id="clip0_1423_17979">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const users = (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.3403 11.0898C11.0003 11.0898 12.3603 9.72978 12.3603 8.06979C12.3603 6.3998 11.0003 5.0498 9.3403 5.0498C7.67031 5.0498 6.32031 6.3998 6.32031 8.06979C6.32031 9.72978 7.67031 11.0898 9.3303 11.0898H9.3403Z"
      stroke="#0E86D4"
      strokeWidth="1.49999"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.25 19.4494V17.7294C3.25 15.7294 4.86999 14.1094 6.86998 14.1094H12.29C14.29 14.1094 15.9099 15.7294 15.9099 17.7294V19.4494"
      stroke="#0E86D4"
      strokeWidth="1.49999"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.8796 11.9497C18.1096 11.9497 19.1196 10.9397 19.1196 9.70972C19.1196 8.46972 18.1096 7.46973 16.8796 7.46973C15.6396 7.46973 14.6396 8.46972 14.6396 9.70972C14.6396 10.9397 15.6396 11.9497 16.8796 11.9497Z"
      stroke="#0E86D4"
      strokeWidth="1.49999"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5195 14.1895H19.0595C20.5395 14.1895 21.7395 15.3894 21.7395 16.8694V18.1494"
      stroke="#0E86D4"
      strokeWidth="1.49999"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export {
  appstorebtn,
  brandlogo,
  chevronDown,
  googleplaybtn,
  gradient,
  headerImage,
  smilinglady,
  smilinglady2,
  downArrow,
  switchcommunity,
  master,
  friends,
  frontarrow,
  gclub,
  gclubbig,
  moneyman,
  amount,
  amountsmall,
  checkIcon,
  membership,
  events,
  discussion,
  payment,
  courses,
  plusIcon,
  closeIcon,
  sendIcon,
  chatIcon,
  chatIconWhite,
  closeIconOverlay,
  hamburgerIcon,
  one,
  two,
  three,
  estateheader,
  fitnessheader,
  manageImage,
  moneyIcon,
  protectionIcon,
  personIcon,
  likeIcon,
  estate1,
  estate2,
  estate3,
  estate4,
  estate5,
  estate6,
  estate7,
  managefitness,
  fitness1,
  fitness2,
  fitness3,
  fitness4,
  fitness5,
  fitness6,
  fitness7,
  estateheaderImage,
  estatesignup,
  fitnessheaderImage,
  fitnesssignup,
  pricingCheckIcon,
  dashedIcon,
  question,
  appstorewhitebtn,
  googlewhitebtn,
  brandlogowhite,
  gatepass,
  residentID,
  membershipImage,
  accesscontrolImage,
  productImage1,
  productImage2,
  productImage3,
  p1,
  p2,
  p3,
  p4,
  p5,
  p6,
  closeIcon2,
  emptyState,
  emptyCartState,
  cartIcon,
  scrollTopIcon,
  scrollDownIcon,
  userIcon,
  leftArrowIcon,
  rightArrowIcon,
  userIcon2,
  ordersIcon,
  google,
  apple,
  calender,
  mapIcon,
  mapIcon25,
  trashCan,
  editIcon,
  copyIcon,
  replyIcon,
  retryArrow,
  uploadIcon,
  searchIcon,
  searchWhiteIcon,
  searchIcon24,
  timeIcon,
  users,
  internationalCodes,
};
